import 'angular:locale/data:de';
import 'angular:locale/data:sv';
import 'angular:locale/data:hu';
import 'angular:locale/data:en';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
